import axios from 'axios'
import { get, cloneDeep } from 'lodash'
import store from './store'

export const clientFactory = (window) => {
  const axiosClient = axios.create({
    baseURL: window.location.origin
  })

  axiosClient.setAuthorization = function setAuthorization(nonce) {
    const headers = cloneDeep(this.defaults.headers)

    headers.Authorization = `Bearer ${nonce}`

    this.defaults.headers = headers
  }

  return (clientStore) => {
    if (typeof clientStore === 'undefined') {
      throw new Error('`clientStore` must be the first parameter to the client')
    }

    let currentNonce = get(clientStore.getState(), 'login.session.nonce')

    if (currentNonce) {
      axiosClient.setAuthorization(currentNonce)
    }

    clientStore.subscribe(() => {
      const previousNonce = currentNonce
      currentNonce = get(clientStore.getState(), 'login.session.nonce')

      if (currentNonce !== previousNonce) {
        axiosClient.setAuthorization(currentNonce)
      }
    })

    return axiosClient
  }
}

const client = clientFactory(global.window)(store)

export default client

